<app-overview [overviewFilters]="filters.overviewFilters" [searchFunction]="searchTermFunction"
              (resultsFound)="renderRecords($event, false)"
              [isEmpty]="isEmpty" [facetNameFormatter]="nameFormatter" [facetsLoading]="facetsLoading" [facets]="facets"
              [otherFacets]="otherFacets"
              (facetFiltersChanged)="facetFiltersChanged($event)" (loadNextPage)="loadNextPage()"
              (filtersCleared)="clearFilters($event)"
              [quickViews]="quickViews" [specificFacetFiltersTemplate]="specificFacetFilters"
              [virtualScroll]="true" [itemSize]="105" [virtualData]="data"
              [virtualItemTemplate]="harbourDuesItemTemplate" [virtualTrackBy]="trackByRecord">
  <div class="header-bar d-flex">
    <div class="d-none d-sm-flex align-items-center ms-3">
      <span class="text-muted">
        <app-loading-icon [loading]="facetsLoading">{{ totalCount }}</app-loading-icon>
        visits
      </span>
    </div>
    <div class="d-flex align-items-center ms-3">
      <div class="dropdown">
        <button class="btn btn-plain text-primary d-inline-flex align-items-center py-1 p-lg-2 p-1"
                data-bs-toggle="dropdown" aria-expanded="false">
          <div class="d-none d-lg-block">
            {{ sortingFormatter(sortingProperty) }}
            <div class="d-inline-block"><i class="fa fa-fw fa-light fa-chevron-down ms-1"></i></div>
          </div>
          <div class="d-block d-lg-none">
            <div class="d-inline-block">
              <i class="fa fa-fw fa-light fa-long-arrow-up"></i>
              <i class="fa fa-fw fa-light fa-long-arrow-down" [style.margin-left.rem]="-0.7"></i>
            </div>
          </div>
        </button>
        <ul class="dropdown-menu">
          @for (property of sortingProperties; track property) {
            <li>
              <button class="dropdown-item d-flex justify-content-between px-3"
                      [ngClass]="sortingProperty === property ? 'text-primary' : ''"
                      (click)="changeSorting(property)">
                <span>{{ sortingFormatter(property) }}</span>
                @if (sortingProperty === property) {
                  <i class="fa fa-fw fa-light fa-check"></i>
                }
              </button>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
  <div class="empty-container col-12 h-100 d-flex align-items-center justify-content-center flex-column">
    <img src="/assets/new-portvisit/no-results-icon-port-visit.svg" alt="No visits found icon" class="mb-2"/>
    <span class="h1 mb-2">No ship ahoy...</span>
    @if (filters.overviewFilters.selectedQuickView !== quickViews[0]) {
      @if (hasActiveFacetFilters) {
        <span class="text-secondary">
          <span>Try </span>
          <span class="link-primary underline-primary cursor-pointer"
                (click)="clearFilters(facetUtils.clearFilters(filters.overviewFilters.term))">clearing the filters</span>
          <span> or go to the </span>
          <span class="link-primary underline-primary cursor-pointer"
                (click)="filters.overviewFilters.selectedQuickView = quickViews[0]; facetFiltersChanged(filters.overviewFilters)">{{ quickViews[0].name }}</span>
          <span> quick view</span>
        </span>
      } @else {
        <span class="text-secondary">
          <span>Try going to the </span>
          <span class="link-primary underline-primary cursor-pointer"
                (click)="filters.overviewFilters.selectedQuickView = quickViews[0]; facetFiltersChanged(filters.overviewFilters)">{{ quickViews[0].name }}</span>
          <span> quick view</span>
        </span>
      }
    } @else {
      @if (hasActiveFacetFilters) {
        <span class="text-secondary">
          <span>Try </span>
          <span class="link-primary underline-primary cursor-pointer"
                (click)="clearFilters(facetUtils.clearFilters(filters.overviewFilters.term))">clearing the filters</span>
        </span>
      } @else {
        <span class="text-secondary">Try adjusting your filters or search term</span>
      }
    }
  </div>
</app-overview>

<ng-template #harbourDuesItemTemplate let-summary>
  <app-harbour-dues-overview-item [summary]="summary" [term]="searchTerm"
    (zoomVesselImage)="openVesselImageModal($event)"></app-harbour-dues-overview-item>
</ng-template>
<!-- Modal for the vessel image, kept outside the virtualized list so it is never recycled -->
<div class="modal" #vesselImageModal tabindex="-1" role="dialog" aria-labelledby="vesselImageModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document" style="--bs-modal-width: fit-content; top:0;">
    <div class="modal-content border-0">
      <div class="modal-body p-0">
        <button type="button" class="btn btn-close btn-close-white btn-plain" data-bs-dismiss="modal" aria-label="Close"
          style="background-color: transparent; border-width: 0; position:fixed; top:20px; right:20px;">
        </button>
        <img style="max-height:90vh; max-width:90vw" src="{{zoomedVesselImageUrl || '/assets/new-portvisit/no-vessel-image.svg'}}" alt="Vessel image">
      </div>
    </div>
  </div>
</div>

<ng-template #specificFacetFilters>
  <div class="col-md-12">
    <app-facet-date-range [ranges]="ranges" [filterName]="'Arrival date'" (ngModelChange)="arrivalDateChanged($event)"
                          [(ngModel)]="filters.overviewFilters.filters.timeRange"></app-facet-date-range>
  </div>
</ng-template>
